import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconContentBlock32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconContentBlock32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19 14h-1V3h8a4 4 0 0 1 4 4v7zm1-9v7h8V7a2 2 0 0 0-2-2zM6 11a2 2 0 0 1 2-2h6v7H6zm0 7v5a2 2 0 0 0 2 2h6v-7zm10 0v7h6a2 2 0 0 0 2-2v-5zm0-2V7H8a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4v-7z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconContentBlock32);
